module.exports = __webpack_public_path__ + "ef69c3267a99590b246c5b929e706265.fbx";